import React from 'react'
import injectStyles from 'react-jss'

import DatePicker from 'rc-calendar/lib/Picker'
import Calendar from 'rc-calendar'
import moment from 'moment'
import { styles } from './styles'
import ArrowIcon from 'Assets/Images/icons/arrow'

const calendar = <Calendar />

const DateRangeSelector = ({
  title,
  value,
  onChange,
  disabled = false,
  classes,
}) => (
  <div className={classes.container}>
    <span className={classes.datePickerHeaderTitle}>{title}</span>
    <div className={classes.inputWrapper}>
      <DatePicker
        animation="slide-up"
        value={value ? moment(value) : value}
        calendar={calendar}
        onChange={onChange}
        disabled={disabled}
      >
        {({ value }) => {
          return (
            <input
              className={classes.input}
              value={value ? moment(value).format('DD/MM/YYYY') : 'ALL'}
            />
          )
        }}
      </DatePicker>
      <ArrowIcon className={classes.icon} />
    </div>
  </div>
)

export default injectStyles(styles)(DateRangeSelector)



// WEBPACK FOOTER //
// ./src/Components/DateRangeSelector/index.js